import React, { useEffect } from 'react'
import CustomValuesHook from '../../../../Hooks/customValuesHook'
import { useLocation, useNavigate } from 'react-router-dom'
import axios from 'axios'
import { DSLoading } from '../../../../components/images_module'
import { toast } from 'react-toastify'
import { checkLocalStorageAndProceed, clearLocalStorageAndProceed, setToken } from '../../../../components/helper'

const LoginAs = () => {
    const [states, setStates] = CustomValuesHook({ displayLoading: false })
    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {

        if (location.search.indexOf("OaaLoginCode") > -1) {
            clearLocalStorageAndProceed("token", () => {
                handleLoginAs()
            })

        }
    }, [])

    const handleLoginAs = async () => {
        setStates({ displayLoading: true })
        var oaaLoginId = extractOaaLoginIdCode();

        try {
            axios.defaults.headers.common['x-oaa-login-code'] = oaaLoginId;
                    axios.post(`${process.env.REACT_APP_CORE_API_ENDPOINT}/token`,
                {
                    grant_type: 'password',
                    username: 'oaaLogin',
                    password: 'p@ssword'
                }).then((loginResponse: any) => {
                    clearLocalStorageAndProceed("token", () => {
                        localStorage.setItem("token", loginResponse?.data?.access_token)
                        localStorage.setItem("portalExtraInfo", JSON.stringify(loginResponse?.data?.ExtraInfo))
                        localStorage.setItem("dsTokenExpiration", loginResponse?.data?.expires_in?.toString())
                        checkLocalStorageAndProceed("token", () => {
                            window.location.href = "/#/dashboard"
                        })
                    })


                })





        } catch (error) {
            toast.error('بروز خطا در عملیات ورود')
        }


    }

    if (states.displayLoading) {
        return (<div id="email-verification-loading" >
            <div className="backe" > </div>
            <div className="loading-context" >
                <div className="content" >
                    لطفاً منتظر باشید...
                </div>
                <img src={DSLoading} alt='daftareshoma' />
            </div>
        </div>
        )
    }
    return null
}

export default LoginAs


function extractOaaLoginIdCode() {

    var keyName = 'oaaLoginCode='.toLowerCase();
    var address = window.location.href.toLowerCase();

    var startIndexOfKeyName = address.indexOf(keyName);

    if (startIndexOfKeyName === -1)
        return;

    var startIndex = startIndexOfKeyName + keyName.length;
    return address.substring(startIndex);
}